import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutComponent } from './pages/about/about.component';
import { FleetComponent } from './pages/fleet/fleet.component';
import { CrewComponent } from './pages/crew/crew.component';
import { ReservationComponent } from './pages/reservation/reservation.component';
import { FlyConditionsComponent } from './pages/fly-conditions/fly-conditions.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { HomeComponent } from './pages/home/home.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { AirplaneGalleryComponent } from './pages/fleet/airplane-gallery/airplane-gallery.component';
import { SummaryComponent } from './pages/summary/summary.component';


const routes: Routes = [
  //{ path: '', component: HomeComponent },
  { path: '', component: AboutComponent },
  { path: 'about', component: AboutComponent },
  { path: 'fleet', component: FleetComponent },
  { path: 'fleet/airplane-gallery/:id', component: AirplaneGalleryComponent },
  { path: 'crew', component: CrewComponent },
  { path: 'reservation', component: ReservationComponent },
  { path: 'fly-conditions', component: FlyConditionsComponent },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'page-not-found', component: PageNotFoundComponent },
  { path: 'summary', component: SummaryComponent },
  { path: '**', redirectTo: 'page-not-found' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
